import React from 'react';
import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonToolbar } from '@ionic/react';
import { Link } from 'react-router-dom';

//	L O C A L I Z A T I O N

import { locale___MdDishViewModal } from './md-dish-view.locale';

//	S T Y L E

import './md-dish-view.style.scss';

//	S T A T E   -   P R O P S

import { props___MdDishViewModal, state___MdDishViewModal, state___MdDishViewModal___default } from './md-dish-view.state';

//	T Y P E S

import { type___modal___config } from '../../types/types.modals';
import { type___api___response } from '../../types/type.api';

//	F U N C S

import { funcs_measurements } from '../../funcs/funcs.measurements';
import { funcs_numbers } from '../../funcs/funcs.numbers';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';
import { service_RestApiService } from '../../services/service-api';

//	C O M P O N E N T S

import ComGalleryPlaceholderComponent from '../../components/com-gallery-placeholder/com-gallery-placeholder';
import ComSpinnerInlineComponent from '../../components/com-spinner-inline/com-spinner-inline';

//	C L A S S

export default class MdDishViewModal extends React.Component<props___MdDishViewModal, state___MdDishViewModal> {

//#region 																							C O N F I G

	private readonly MdDishViewModal___modal_config: type___modal___config = {
		cssClass: 'modal---custom',
		breakpoints: [ 1 ],
		backdropDismiss: true,
		handle: true,
		initialBreakpoint: 1,
		keyboardClose: true,
		showBackdrop: true,
		onDidPresent: () : void => this.event___onDidPresent(),
		onDidDismiss: () : void => this.event___onDidDismiss(),
	};

//#endregion

//#region 																							D E C L A R A T I O N S
		
	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

	private readonly funcs___measurements: funcs_measurements = new funcs_measurements();
	private readonly funcs___numbers: funcs_numbers = new funcs_numbers();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___MdDishViewModal,
	) {
		super(props);
		this.state = state___MdDishViewModal___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___dish_props = async () : Promise<void> => {
		const ___temp___dish_props: type___api___response = await this._API.public___read_dish(this.props.dish_id!)


		console.log('___temp___dish_props', ___temp___dish_props)

		this.setState({
			dish___props: ___temp___dish_props.data,
			dish___props___is_loading: false,
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	private event___onDidPresent() : void {
		this.setState({
			...state___MdDishViewModal___default
		}, async () : Promise<void> => await this.read_props___dish_props());
	}

	private event___onDidDismiss() : void {
		this.setState({
			...state___MdDishViewModal___default
		});
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return (
			<IonModal isOpen={ this.props.isOpen } {...this.MdDishViewModal___modal_config}>

				<IonHeader>
					<IonToolbar>
						<IonButtons slot="end">
							<IonButton onClick={this.props.event___onDidDismiss}>
								<span className="modal---close-button">
									{ this._LOCALE.translate(locale___MdDishViewModal.topBarButton___close) }
								</span>
							</IonButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>
					{(this.state.dish___props___is_loading === true) ? (<>
						<br />
						<br />
						<br />
						<br />
						<ComSpinnerInlineComponent/>
					</>) : (
						<section className="md-digitalmemu-dish-view---container">
							
							<ComGalleryPlaceholderComponent placeholder_path={ '/assets/digitalmenu/categories/' + this.state.dish___props['dish_category']['dish_category_icon'] + '.svg' }/>

							<br />

							<div className="md-digitalmemu-dish-view---container---inner">
							
								<h2>{ this.state.dish___props['dish_category']['dish_category_name'] }</h2>
								<h1>{ this.state.dish___props['dish_name'] }</h1>

								<br />

								{(this.state.dish___props['dish_description'] && this.state.dish___props['dish_description'].length > 0) && (<>
									<p>{ this.state.dish___props['dish_description'] }</p>
									<br />
								</>)}

								<div className="md-digitalmemu-dish-view---container---inner---price">
									{(this.state.dish___props['dish_measurement_unit'] && this.state.dish___props['dish_measurement_unit'] !== null) ? (<>
										<h5>{ this.funcs___numbers.format___price(this.state.dish___props['dish_price'], '€') } </h5>
										<h6> { this.funcs___measurements.price_at_measurements(this.state.dish___props['dish_measurement_unit'], true) }</h6>
									</>) : (
										<h5>{ this.funcs___numbers.format___price(this.state.dish___props['dish_price'], '€') }</h5>
									)}
								</div>

								<br />
								<br />
								<br />

								<div className="md-digitalmemu-dish-view---container---inner---allergens">

									{(this.state.dish___props['dish_allergens'] && this.state.dish___props['dish_allergens'].length > 0) ?( <>
										<h6>{ this._LOCALE.translate(locale___MdDishViewModal.allergens___can_contain) }</h6>
										<section>
											{this.state.dish___props['dish_allergens'].map((___a: any, ___a___idx: number) : React.ReactNode => (
												<div key={___a___idx}>
													<img src={ '/assets/digitalmenu/allergens/' + ___a['dish_allergen_icon'] + '.svg' } />
												</div>
											))}
										</section>
									</>) : (
										<h6>{ this._LOCALE.translate(locale___MdDishViewModal.allergens___not_containing) }</h6>
									)}

									<br />

									<Link to="/info/allergens" onClick={this.props.event___onDidDismiss}>
										<span>{ this._LOCALE.translate(locale___MdDishViewModal.button___allergen_list) }</span>
										<i className="fas fa-chevron-right"></i>
									</Link>

								</div>

							</div>
						</section>
					)}
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
				</IonContent>

			</IonModal>
		);
	}

//#endregion

}